import Tokens from '@/modules/tokens'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_public/_layout/tokens')({
  component: Tokens,
})


